import {Controller} from "@hotwired/stimulus"

export default class extends Controller {
  static values = {
    start: String,
    frequency: {type: String, default: "bi-weekly"}
  }

  connect() {
    if (!this.startValue) return

    // Parse the start date from the data attribute
    this.startDate = new Date(this.startValue)

    // Determine cycle duration based on frequency
    const maxDays = this.frequencyValue === "monthly" ? 28 : 12

    // Calculate end date
    this.endDate = new Date(this.startDate)
    this.endDate.setDate(this.startDate.getDate() + maxDays)

    // Format dates for the input min/max attributes
    const formattedStartDate = this.formatDateForInput(this.startDate)
    const formattedEndDate = this.formatDateForInput(this.endDate)

    // Set the min and max attributes
    this.element.setAttribute("min", formattedStartDate)
    this.element.setAttribute("max", formattedEndDate)

    // Add event listener to prevent manual entry of invalid dates
    this.element.addEventListener("input", this.validateDate.bind(this))
  }

  validateDate(event) {
    const selectedDate = new Date(this.element.value)

    if (selectedDate < this.startDate || selectedDate > this.endDate) {
      // Reset to the current value if it's valid, otherwise to the start date
      const currentValue = new Date(this.element.defaultValue)
      if (currentValue >= this.startDate && currentValue <= this.endDate) {
        this.element.value = this.element.defaultValue
      } else {
        this.element.value = this.formatDateForInput(this.startDate)
      }
    }
  }

  formatDateForInput(date) {
    // Format date as YYYY-MM-DD for input value
    return date.toISOString().split('T')[0]
  }
}